import React from 'react';
import './OnboardingStepRedesign.css';
import OnboardingCardRedesign from './Cards/OnboardingCardRedesign';
import OnboardingCardWithImageRedesign from './Cards/OnboardingCardWithImageRedesign';

export const OnboardingStepRedesign = props => (
  <div className="onboarding-step-redesign text-center">
    <div className="red-step-title mb-4">{props.hero}</div>
    <div className="mb-4 text-dark">
      <p> {props.subtext} </p>
    </div>
    <div className="flex justify-content-center">
      <div className="onboarding-red-row mx-auto justify-content-center">
        {props.cards.map(
          (cardInfo, index) =>
            cardInfo.imageUrl ? (
              <OnboardingCardWithImageRedesign
                {...cardInfo}
                key={index}
                step={props.step}
              />
            ) : (
              <OnboardingCardRedesign
                {...cardInfo}
                key={index}
                step={props.step}
              />
            ),
        )}
      </div>
      <div className="py-4">
        <a className="other-need" onClick={() => props.onSkip(props.step)}>
          Other – I have a different need
        </a>
      </div>
      {props.buttons}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/OnboardingStepRedesign.js